// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Bloomberg UK';

export function BloombergLogoUK() {
  return (
    <svg
      width="100%"
      height="100%"
      version="1.0"
      viewBox="329 600 638.93 96.1"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      fill="currentColor"
      aria-label={TITLE}
      data-component="bloombergLogoUK"
    >
      <path
        d="m341.5 612.4h10.4c9.5 0 13.6 3 13.6 9.1 0 5.3-4.2 8.9-12.5 8.9h-11.4v-18h-0.1zm-12.5 59.7h25.4c13.3 0 26.7-4.8 26.7-20.1 0-9.1-6.4-16-15.2-17v-0.2c7.3-2.2 12.2-7.5 12.2-15.4 0-12.8-10.9-17.7-21.6-17.7h-27.5v70.4zm12.5-31h12c10.2 0 14.9 2.6 14.9 10 0 9.3-9 10.4-15.4 10.4h-11.5v-20.4z"
        fill="currentColor"
      />
      <path d="m389.2 600h11.9v72.1h-11.9v-72.1z" fill="currentColor" />
      <path
        d="m421.1 648.2c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.7 0.1-14-6.8-14-14.3zm-11.9 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.5 0.1-26 10.1-26 25.1z"
        fill="currentColor"
      />
      <path
        d="m478.5 648.2c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.8 0.1-14-6.8-14-14.3zm-12 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.4 0.1-26 10.1-26 25.1z"
        fill="currentColor"
      />
      <path
        d="m525.8 624.4h11.3v7.5h0.2c2.1-4.5 6.7-8.7 14.6-8.7 7.4 0 12.4 2.9 14.9 8.9 3.5-6.1 8.6-8.9 15.7-8.9 12.7 0 17.2 9.1 17.2 20.5v28.5h-11.9v-27.1c0-6-1.8-11.1-8.9-11.1-7.5 0-10.3 6.2-10.3 12.3v25.9h-11.9v-28.5c0-5.9-2.4-9.8-8.2-9.8-7.9 0-10.9 5.8-10.9 12.1v26.1h-11.9v-47.7h0.1z"
        fill="currentColor"
      />
      <path
        d="m649.1 648.2c0 7.5-5.3 14.3-14 14.3-8.8 0-14-6.9-14-14.3 0-7.5 5.3-14.3 14-14.3s14 6.9 14 14.3zm-39.6 23.9h11.3v-7.2h0.2c3.5 5.8 9.8 8.4 16.4 8.4 14.7 0 23.6-10.9 23.6-25.1 0-14.1-9.5-25.1-23.1-25.1-9 0-13.7 4.2-16.2 7.3h-0.3v-30.4h-11.9v72.1z"
        fill="currentColor"
      />
      <path
        d="m678.4 643.5c0.9-6.9 5.3-11.3 12.3-11.3 7.5 0 12 4.4 12.1 11.3h-24.4zm36.4 8.9v-3.3c0-16.6-9.1-26-22.4-26-14.4 0-26 10.1-26 25.1s11.5 25.1 26 25.1c7.6 0 14.6-2.7 20.2-9.6l-8.6-6.5c-3 3.7-6.9 6.5-12.8 6.5-6.7 0-12-4.3-12.8-11.3h36.4z"
        fill="currentColor"
      />
      <path
        d="m722.6 624.4h11.9v7.6h0.2c2.6-5.5 7.9-8.8 14.1-8.8 1.5 0 2.9 0.3 4.3 0.7v11.5c-2-0.5-3.9-0.9-5.8-0.9-11.2 0-12.8 9.5-12.8 12v25.6h-11.9v-47.7z"
        fill="currentColor"
      />
      <path
        d="m779.9 633.9c8.7 0 14.1 5.8 14.1 14 0 8-5.4 14-14.2 14-8.1 0-14-6.3-14-13.8 0-8.4 5.7-14.2 14.1-14.2zm14.1-9.5v7.2h-0.2c-3.5-5.8-9.8-8.4-16.4-8.4-14.7 0-23.6 11-23.6 25.1 0 13.5 9.5 24.5 23.8 24.5 6 0 12.1-2.3 15.6-7h0.2v3.5c0 9.5-3.6 16-15.1 16-6.7 0-11.6-2.5-16.4-6.9l-7.2 9.8c6.8 6 14.8 7.9 23.7 7.9 18.6 0 27-10.9 27-28.2v-43.5h-11.4z"
        fill="currentColor"
      />
      <path
        d="m895.48 647.47c0 4.108-0.706 7.83-2.118 11.167-1.412 3.273-3.337 6.065-5.776 8.375-2.438 2.311-5.326 4.108-8.664 5.391-3.337 1.22-6.963 1.83-10.878 1.83s-7.541-0.61-10.878-1.83c-3.337-1.283-6.257-3.08-8.76-5.391-2.439-2.31-4.364-5.102-5.776-8.375-1.348-3.337-2.022-7.059-2.022-11.167v-43.127h12.13v42.646c0 1.99 0.256 3.979 0.77 5.969 0.513 1.925 1.348 3.658 2.503 5.198 1.219 1.54 2.791 2.792 4.717 3.754 1.989 0.963 4.428 1.444 7.316 1.444s5.295-0.481 7.22-1.444c1.99-0.962 3.562-2.214 4.717-3.754 1.22-1.54 2.086-3.273 2.599-5.198 0.514-1.99 0.771-3.979 0.771-5.969v-42.646h12.129v43.127z"
        fill="currentColor"
      />
      <path
        d="m908.54 604.34h12.13v29.457h0.289l28.495-29.457h16.365l-31.864 31.479 33.982 36.678h-17.039l-29.939-34.175h-0.289v34.175h-12.13v-68.157z"
        fill="currentColor"
      />
    </svg>
  );
}
